<template>
    <el-container v-wechat-title="title" :style="{ height: this.screenHeight - 115 + 'px' }" v-if="this.surgeryId > 0">
        <el-aside width="300px">
            <el-scrollbar wrap-class="scrollbar-wrapper-y" style="height: 100%; background: white">
                <template v-if="validDocumentList.length > 0">
                    <div v-for="g in validDocumentList" :key="g.surgeryId" class="padding10">
                        <div class="align-left font-size12">
                            <span class="el-icon-location fg-primary font-size14" v-if="surgeryId == g.surgeryId"></span>
                            申请时间：{{ (g.surgery && $moment(g.surgery.apply_time).format('YYYY/MM/DD HH:mm')) || '--' }}
                            <span class="circle fg-red borderd" v-if="g.surgery && g.surgery.is_reoperation">再</span>
                            <br>
                            <span class="fg-info">手术状态：{{ g.surgery && g.surgery.surgery_status }}</span><br/>
                            <span class="fg-info">{{ g.surgery && g.surgery.enum_surgery_status>40?'进复苏室时间:':'进手术间时间' }}：
                                {{ (g.surgery && g.surgery.enum_surgery_status>40?$moment(g.surgery && g.surgery.in_recovery_room).format('YYYY/MM/DD HH:mm'):$moment(g.surgery && g.surgery.in_room_time).format('YYYY/MM/DD HH:mm'))|| '--' }}
                            </span>
                        </div>
                        <div :key="index" v-for="(item, index) in g.children">
                            <div class="title align-left padding5" v-if="item.children.length > 0 || item.archivedInfo">
                                <span class="el-icon-document"></span><b>{{ item.label }}</b
                                >&nbsp;&nbsp;({{ item.children.length || 1}})
                            </div>
                            <div class="padding20 padding-none-v" v-if="item.children.length>0">
                                <div v-for="c in item.children" :key="c.index" class="align-left cursor-pointer" @click="loadInstance(c)">
                                    {{ c.label }} &nbsp;&nbsp;<span class="fg-info">{{ c.createby }}</span
                                    >&nbsp;
                                    <span>
                                        <font-awesome-icon :icon="['fas', 'lock']" class="fg-warning" v-if="c.archiveddt"></font-awesome-icon>
                                        <font-awesome-icon :icon="['fas', 'lock-open']" class="fg-warning" v-else></font-awesome-icon>
                                    </span>
                                    <span @click.stop="printDocment(c)">
                                        <span class="el-icon-printer"></span>
                                    </span>
                                </div>
                            </div>
                            <div class="padding20 padding-none-v" v-else>
                                <div v-if="item.archivedInfo" class="align-left cursor-pointer" @click="loadInstance(item)">
                                    {{ item.archivedInfo.docname }} &nbsp;&nbsp;<span class="fg-info">{{ item.archivedInfo.modifier }}</span
                                    >&nbsp;
                                    <span>
                                        <font-awesome-icon :icon="['fas', 'lock']" class="fg-warning" v-if="item.archivedInfo.archivedt"></font-awesome-icon>
                                        <font-awesome-icon :icon="['fas', 'lock-open']" class="fg-warning" v-else></font-awesome-icon>
                                    </span>
                                    <span @click.stop="printDocment(item)">
                                        <span class="el-icon-printer"></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
            </el-scrollbar>
        </el-aside>
        <el-main class="width-p100" style="padding: 0" v-loading="loading">
            <DocFrame v-if="document" ref="doc"
                :docno="document.docno"
                :docbizid="document.docbizid"
                :surgeryId="document.surgeryId"
                :isSurportHtml="document.isSurportHtml"
                :isHide="!document.archived"
                :extraParams="document.extraParams"
            ></DocFrame>
            <pdf v-else-if="src" v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            <div v-else style="margin-top: 40px; line-height: 600px; font-size: 100px; opacity: 0.5"><span class="el-icon-document"></span></div>
        </el-main>
    </el-container>
    <p v-else class="no-surgery">暂无手术</p>
</template>

<script>
import axios from 'axios'
import pdf from '@/common/vue-pdf-4.1.0'
import { mapGetters } from 'vuex'
import printJs from 'print-js'
export default {
    name: `MedicalRecord`,
    components: {
        pdf
    },
    props: {
    },
    data() {
        return {
            surgeryId: parseInt(this.$route.query.surgery_id),
            token: this.$route.query.token,
            currentPage: 1,
            pageCount: 0,
            alivable: false,
            loadingTask: null,
            documentList: [],
            activeDoc: undefined,
            title: `病案浏览`,
            document: undefined,
            src: undefined,
            numPages: 0,
            loading: false,
            isShowSendPrintMessage: this.$root.isShowSendPrintMessage,
            DocumentConfig: null,
            DocArchivedList: []
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.getToken()
        }
    },
    computed: {
        ...mapGetters([`screenHeight`, `currentUser`]),
        validDocumentList() {
            let nd = _.filter(this.documentList, d => (d.children && d.children.length > 0) || (!d.IsSurportHtml && d.is_show_medical))
            let r = _.reduce(_.groupBy(nd, `surgeryId`), function(result, v, key) {
                result.push({
                    surgeryId: key,
                    surgery: v[0].surgery,
                    children: v
                })
                return result
            }, [])
            console.log(`r`, r)
            return _.orderBy(r, `surgery.apply_time`)
        }
    },
    mounted() {
        let that = this
        this.loadAssociatedOperations().then(surgeries => {
            that.loadDocArchived(surgeries).then(info => {
                this.loadDocumentConfig().then(config => {
                    this.loadDocumentList(surgeries)
                })
            })
        })
    },
    methods: {
        getToken() {
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/GetAuthToken`, {
                headers: { 'content-type': `application/x-www-form-urlencoded` }
            })
            req.then(res => {
                console.log(`11111111111111111111111`, res)
                if (res != null && res.Status === `SUCCESS`) {
                    sessionStorage.setItem(`doctoken`, res.Content)
                }
            }).catch(err => {
                console.log(err)
            })
        },
        loadAssociatedOperations() {
            if (!this.surgeryId) {
                return Promise.resolve([])
            }
            return this.myaxios.post(`api/Intraoperative/Anaesthesia/AssociatedOperations?surgeryInfoId=${this.surgeryId}`)
        },
        loadDocumentConfig() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/AcisSystem/DocumentConfig/Get`)
                req.then(DocumentConfig => {
                    that.DocumentConfig = DocumentConfig
                    resolve(DocumentConfig)
                })
            })
        },
        loadDocArchived(surgeries) {
            let that = this
            return new Promise((resolve, reject) => {
                let req = _.map(surgeries, d => {
                    return this.myaxios.get(`/api/AcisSystem/DocumentConfig/GetArchivedBySurgeryId?surgeryId=${d.id}`)
                })
                this.myaxios.all(...req).then(([...data]) => {
                    that.DocArchivedList = _.reduce(data, function(result, v, index) {
                        result.push(...v)
                        return result
                    }, [])
                    console.log(`DocArchivedList`, that.DocArchivedList)
                    resolve(that.DocArchivedList)
                })
            })
        },
        loadDocumentList(surgeries) {
            let that = this
            if (!that.surgeryId || surgeries.length == 0) {
                return false
            }
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/DocCenter/Setting/GetDicDocManagementList`, { headers: { 'content-type': `application/x-www-form-urlencoded`, 'Authorization': sessionStorage.getItem(`doctoken`) }, params: { deptno: `acis2020`, permission: `0-11111111111`, vid: that.surgeryId } })
            let req2 = _.map(surgeries, d => {
                return this.myaxios.get(`/api/Operation/Home/ArchiveList?surgeryInfoId=${d.id}`)
            })
            this.myaxios.all(req, ...req2).then(([data, ...data2]) => {
                that.documentList = _.reduce(data2, function(result, v, index) {
                    // if (v.length == 0) return
                    let r = []
                    let surgery = _.find(surgeries, { id: parseInt(v[0] && v[0].biz_surgery_info_id || that.surgeryId) })
                    if (v.length > 0) {
                        r = [{
                            surgeryId: v[0].biz_surgery_info_id,
                            surgery: surgery,
                            index: `MZYFS`,
                            hasChildren: true,
                            children: _.map(v, d => {
                                return {
                                    surgeryId: d.biz_surgery_info_id,
                                    index: d.enum_record_type,
                                    docno: -d.enum_record_type,
                                    label: d.record_type,
                                    archiveddt: d.is_archived ? d.archive_date : ``
                                }
                            }) || [],
                            label: `麻醉与复苏`
                        }]
                    }
                    r = r.concat(_.map(data.data, dr => {
                        let docconfig = that.DocumentConfig && _.find(that.DocumentConfig, d3 => d3.document_id == dr.DocNo)
                        let d = { ...dr }
                        d.is_show_medical = docconfig && docconfig.is_show_medical
                        d.surgeryId = v[0] && v[0].biz_surgery_info_id || that.surgeryId
                        d.surgery = surgery
                        d.index = `${d.DocNo}`
                        d.hasChildren = d.IsSurportHtml
                        d.children = []
                        d.label = d.DocName
                        if (!d.IsSurportHtml && d.is_show_medical) {
                            d.archivedInfo = that.DocArchivedList && _.find(that.DocArchivedList, da => parseInt(da.docid) == parseInt(d.DocId || d.DocNo) && da.biz_surgeryInfo_id == parseInt(d.surgeryId))
                        }
                        return d
                    }))
                    result.push(...r)
                    return result
                }, [])
                _.forEach(this.documentList, d => {
                    if (d.hasChildren && d.DocNo > 0) {
                        this.loadInstances(d.index, d.surgeryId)
                    }
                })
                console.log(`documentList`, that.documentList)
            }).catch(e => {
                console.log(e)
            })
        },
        loadInstance(doc) {
            if (doc.docno > 0) {
                this.src = undefined
                this.document = {
                    docno: doc.docno,
                    surgeryId: this.surgeryId,
                    docbizid: doc.docbizid
                }
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else if (doc.DocNo > 0) {
                this.src = undefined
                this.document = {
                    docno: doc.DocNo,
                    surgeryId: this.surgeryId,
                    isSurportHtml: doc.IsSurportHtml,
                    archived: doc.archivedInfo && doc.archivedInfo.archivedt
                }
                this.$nextTick(() => {
                    this.$refs.doc.loadDocument()
                })
            } else {
                this.document = undefined
                this.loading = true
                let req = ``
                if (doc.archiveddt.length > 0) {
                    req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${doc.index}`)
                } else {
                    req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${this.surgeryId}&recordType=${doc.index}`)
                }
                req.then(data => {
                    this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                    this.src.then(content => {
                        this.numPages = content.numPages
                        this.loading = false
                    })
                }).catch(e => {
                    console.log(e)
                    this.loading = false
                })
            }
        },
        loadInstances(docno, surgeryId) {
            let submenu = _.find(this.documentList, d => { return d.DocNo == docno && d.surgeryId == surgeryId })
            let req = axios.get(`${this.$root.DOCSERVICE_BASE}/Wth/QueryInstances`,
                { headers: { 'content-type': `application/x-www-form-urlencoded` },
                    params: { docid: docno, dept: `acis2020`, vid: surgeryId } })
            req.then(data => {
                submenu.children = _.filter(data.Content, d => { return d.istemplate == `0` }).map(d => {
                    d.index = `${d.docbizid}`
                    d.docno = submenu.DocNo
                    d.label = d.docname
                    return d
                })
            })
        },
        printDocment(c) {
            let that = this
            if (c.docno > 0 || c.DocNo > 0) {
                that.document.extraParams = { isShowSendPrintMessage: that.isShowSendPrintMessage }
                this.$refs.doc.print()
                // this.$store.dispatch(`PRINT_PDF`, {
                //     host: this.$root.DOCSERVICE_BASE,
                //     params: Object.assign(
                //         {
                //             docid: c.docid || c.docno,
                //             id1: this.surgeryId,
                //             docbizid: c.docbizid,
                //             from: this.$moment().format(`YYYYMMDDHHmm`),
                //             to: this.$moment().format(`YYYYMMDDHHmm`)
                //         },
                //         { isShowSendPrintMessage: that.isShowSendPrintMessage }
                //     )
                // })
            } else {
                let req = this.myaxios.get(`/api/Operation/Home/ArchivePdf?surgeryInfoId=${this.surgeryId}&recordType=${c.index}`)
                req.then(data => {
                    req.then(data => {
                        printJs({ printable: data,
                            type: `pdf`,
                            base64: true,
                            onPrintDialogClose: () => {
                                if (that.isShowSendPrintMessage === `true`) {
                                    setTimeout(function() {
                                        that.$confirm(`提示`, {
                                            title: `提示`,
                                            message: `请确认打印是否已完成`,
                                            confirmButtonText: `打印完成`,
                                            cancelButtonText: `打印未完成`,
                                            type: `warning`
                                        }).then(() => {

                                        }).catch(e => {
                                            console.log(e)
                                        })
                                    }, 2000)
                                }
                            } })
                    }).catch(e => console.log(e))
                }).catch(e => {
                    console.log(e)
                    this.loading = false
                })
            }
        }
    },
    watch: {
        $route: function(newUrl, oldUrl) {
            let that = this
            that.surgeryId = newUrl.query.surgery_id
            that.document = undefined
            that.src = undefined
            that.loadAssociatedOperations().then(surgeries => {
                that.loadDocArchived(surgeries).then(info => {
                    that.loadDocumentConfig().then(config => {
                        that.loadDocumentList(surgeries)
                    })
                })
            })
        },
        'document.occurdate': function() {
            this.document.fromDt = this.document.occurdate
            this.document.toDt = this.document.occurdate
            this.$nextTick(() => {
                this.$refs[`doc-new`].loadDocument()
            })
        },
        'document.daterange': function() {
            this.document.fromDt = this.document.daterange[0]
            this.document.toDt = this.document.daterange[1]
            this.$nextTick(() => {
                this.$refs[`doc-new`].loadDocument()
            })
        },
        'document.templateid': function() {
            this.$nextTick(() => {
                this.$refs[`doc-new`].loadDocument()
            })
        },
        isTemplate: function() {
            let that = this
            that.loadAssociatedOperations().then(surgeries => {
                that.loadDocArchived(surgeries).then(info => {
                    that.loadDocumentConfig().then(config => {
                        that.loadDocumentList(surgeries)
                    })
                })
            })
        }
    }
}
</script>
<style scoped lang="less" >
@h-header: 30px;
.pdf {
    width: 100%;
    height: 100%;
    padding: @h-header 0px;
    /*background: whitesmoke;*/
}
.pdf-header {
    line-height: @h-header;
    background: whitesmoke;
    position: absolute;
    width: 100%;
    height: @h-header;
    z-index: 2;
}
ul,
li {
    list-style: none;
}
.no-surgery {
    line-height: 600px;
    font-size: 24px;
    opacity: 0.5;
}
</style>
<style lang="less">
.document-list {
    .el-submenu__icon-arrow {
        // position: absolute !important;
        left: -220px;
    }
    .btn {
        position: absolute;
        right: 20px;
        top: 50%;
        margin-top: -12px;
        font-size: 16px;
        z-index: 2;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/MedicalRecord/Index.vue